import * as d3 from "d3";
import { convertSvgAttribute } from "utils/convertSvgAttribute";
export var initGrid = function initGrid(ref, margin) {
  var svg = d3.select(ref);
  var width = convertSvgAttribute(svg.style("width"));
  svg.append("g").attr("class", "xGrid").attr("transform", "translate(".concat(-width, ",").concat(margin.top, ")"));
  svg.append("g").attr("class", "yGrid").attr("transform", "translate(".concat(-width, ",").concat(margin.top, ")"));
};
export function updateGridLines(_ref) {
  var svg = _ref.svg,
    margin = _ref.margin,
    x = _ref.x,
    xTicks = _ref.xTicks,
    yTicks = _ref.yTicks;
  var svgWidth = convertSvgAttribute(svg.style("width"));
  var svgHeight = convertSvgAttribute(svg.style("height"));
  var width = svgWidth - margin.left - margin.right;
  var height = svgHeight - margin.top - margin.bottom;
  var y = d3.scaleLinear().domain([0, yTicks]).range([0, height]);
  var calleeX = d3.axisBottom(x).ticks(xTicks).tickSize(height).tickFormat("").tickSizeOuter(0);
  var calleeY = d3.axisLeft(y).ticks(yTicks).tickSize(-width).tickSizeOuter(0).tickFormat("");
  svg.select(".xGrid").transition().ease(d3.easeQuad).duration(400).attr("transform", "translate(".concat(margin.left, ",").concat(margin.top, ")")).call(calleeX);
  svg.select(".yGrid").transition().ease(d3.easeQuad).duration(400).attr("transform", "translate(".concat(margin.left, ",").concat(margin.top, ")")).call(calleeY);
  svg.selectAll(".xGrid").selectAll("path").style("visibility", "hidden");
  svg.selectAll(".yGrid").selectAll("path").style("visibility", "hidden");
}